export default __webpack_public_path__ + "static/media/Story-banner.7582e9c4.png";